import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { DefaultModalActions } from 'shared/ui/Modal/ui/DefaultModal/DefaultModalActions'
import { Button, InputCheckbox, SpinnerLoader, Typography } from 'shared/ui'
import { numberFormat } from 'shared/lib'
import { type ActivateWorkflowModalStore } from 'pages/workflows/ui/ActivateWorkflowModal/store/ActivateWorkflowModalStore'
import styles from './styles.module.scss'

type IActivateWorkflowModalUiProps = { store: ActivateWorkflowModalStore }

export const ActivateWorkflowModalUi = observer(({ store }: IActivateWorkflowModalUiProps) => {
  const {
    onClose,
    onPublish,
    isEnrollExist,
    setIsEnrollExist,
    isReEnroll,
    setIsReEnroll,
    contactsCount,
    loadingContactsCount,
  } = store

  const [loading, setLoading] = useState(false)

  const handlePublish = async () => {
    setLoading(true)
    await onPublish()
    setLoading(false)
  }
  return (
    <>
      <Typography ariaLabel={'Review Workflow'} variant={'heading-lg'} className={styles.title}>
        Review Workflow
      </Typography>
      <div className={styles.wrapInfo}>
        <div className={styles.info}>
          {loadingContactsCount ? (
            <div className={styles.loading}>
              <SpinnerLoader ariaLabel={'ActivateWorkflowModalUi'} />
            </div>
          ) : (
            <Typography ariaLabel={'count'} variant={'body-xxl-medium'}>
              {numberFormat({ value: contactsCount })}
            </Typography>
          )}

          <Typography ariaLabel={'info'} variant={'body-md-regular'} color={'tertiary'}>
            Contacts meet the enrolment criteria
          </Typography>
        </div>
      </div>
      <div className={styles.controls}>
        <InputCheckbox
          checked={isEnrollExist}
          onChecked={() => setIsEnrollExist(!isEnrollExist)}
          label={'Enroll existing contacts that meet the criteria'}
        />
        <InputCheckbox
          checked={isReEnroll}
          onChecked={() => setIsReEnroll(!isReEnroll)}
          label={'Allow contacts to be enrolled again in this workflow after completion'}
        />
      </div>
      <DefaultModalActions>
        <Button
          typeBtn={'contained'}
          text={'Cancel'}
          size={'medium'}
          contained={'secondary'}
          onClick={onClose}
        />
        <Button
          typeBtn={'contained'}
          text={'Publish'}
          size={'medium'}
          contained={'primary'}
          onClick={handlePublish}
          disabled={loadingContactsCount}
          loading={loading}
        />
      </DefaultModalActions>
    </>
  )
})
